const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const contentId = this.dataset.contentId;
      const content = document.getElementById(contentId);

      tabContents.forEach(function(c) {
        c.classList.remove('active');
      });

      tabs.forEach(function(t) {
        t.classList.remove('active');
      });

      this.classList.add('active');
      if(content) content.classList.add('active');
    });
  });